module.exports = __webpack_public_path__ + "img/loyalty-reward-item-free.51c180ec.svg";